export default __webpack_public_path__ + "static/media/13-shine.048c5799.png";